import { IsIn, IsNumber, IsOptional, IsString } from 'class-validator';
import { FIELD_VALUE_SOURCES, type FieldValueSource } from '../../label/field-value-source';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

/**
 * Sparse tenant override on a GLOBAL ingredient (PATCH). Every field is
 * optional: only the keys present are applied, the rest stay untouched. A
 * physical factor sent as `null` clears it back to the global value. A factor
 * and its `source` must travel together (validated in the service: a value
 * without a source, or a source without a value, is rejected).
 *
 * `ediblePortionFactor`, when set, must be in (0, 1] — a null value stays
 * "incomplete" and is NEVER defaulted to 1 (see the schema comment on
 * `Ingredient.ediblePortionFactor`).
 *
 * Rejected at the service level when the target ingredient is a tenant custom
 * ingredient or belongs to another tenant: overrides exist only on global rows.
 */
export class IngredientOverrideInputDto {
  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  aliasName?: string | null;

  @IsOptional()
  @IsNumber()
  densityGPerMl?: number | null;

  @IsOptional()
  @IsIn(FIELD_VALUE_SOURCES)
  densitySource?: FieldValueSource | null;

  @IsOptional()
  @IsNumber()
  pieceWeightG?: number | null;

  @IsOptional()
  @IsIn(FIELD_VALUE_SOURCES)
  pieceWeightSource?: FieldValueSource | null;

  @IsOptional()
  @IsNumber()
  ediblePortionFactor?: number | null;

  @IsOptional()
  @IsIn(FIELD_VALUE_SOURCES)
  ediblePortionSource?: FieldValueSource | null;
}
